import { useEffect, useState } from "react";

type Result =
  | { status: "loading" }
  | { status: "not_found" }
  | { status: "found"; hasSpeakingLevel: boolean };

const query = `
  query CheckUserHasSpeakingLevel($email: String!) {
    checkUserHasSpeakingLevel(email: $email)
  }
`;

export function useGetUserSpeakingLevelByEmail(email: string | null): Result {
  const [result, setResult] = useState<Result>({ status: "loading" });

  useEffect(() => {
    if (!email) {
      setResult({ status: "not_found" });
      return;
    }

    fetch(import.meta.env.VITE_API_BASE_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query, variables: { email } }),
    })
      .then((res) => res.json())
      .then((json) => {
        const value = json?.data?.checkUserHasSpeakingLevel;
        if (value === null || value === undefined) {
          setResult({ status: "not_found" });
        } else {
          setResult({ status: "found", hasSpeakingLevel: value });
        }
      })
      .catch(() => setResult({ status: "not_found" }));
  }, [email]);

  return result;
}
